import { PhotoSwipeLightbox } from 'vendor';

class K7GewaehrleistungslabelZoom extends HTMLElement {
  connectedCallback() {
    if (this.dataset.k7Init === 'true') return;
    this.dataset.k7Init = 'true';
    this.addEventListener('click', () => this.open());

    if (this.hasAttribute('data-k7-portal')) {
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-k7-gewaehrleistungslabel-open]');
        if (!trigger) return;
        event.preventDefault();
        this.open();
      });
    }
  }

  get photoswipe() {
    if (this._photoswipe) return this._photoswipe;

    const photoswipe = new PhotoSwipeLightbox({
      pswpModule: () => import('photoswipe'),
      bgOpacity: 1,
      maxZoomLevel: 4,
      arrowPrev: false,
      arrowNext: false,
      counter: false,
      zoom: true,
      closeTitle: window.themeVariables?.strings?.closeGallery,
      zoomTitle: window.themeVariables?.strings?.zoomGallery,
      errorMsg: window.themeVariables?.strings?.errorGallery,
      closeSVG: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
        <path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/>
        <path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/>
        <path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/>
      </svg>`
    });

    photoswipe.addFilter('thumbEl', (thumbEl, data) => data.thumbnailElement);
    photoswipe.init();
    this._photoswipe = photoswipe;
    return photoswipe;
  }

  open() {
    const image = this.querySelector('img');
    if (!image) return;

    this.photoswipe.loadAndOpen(0, [
      {
        thumbnailElement: image,
        src: image.currentSrc || image.src,
        msrc: image.currentSrc || image.src,
        width: parseInt(image.getAttribute('width'), 10) || 1785,
        height: parseInt(image.getAttribute('height'), 10) || 2526,
        alt: image.alt
      }
    ]);
  }
}

if (!customElements.get('k7-gewaehrleistungslabel-zoom')) {
  customElements.define('k7-gewaehrleistungslabel-zoom', K7GewaehrleistungslabelZoom);
}
